import { createGlobalStyle } from 'styled-components'

import oxygenBoldEot from 'assets/fonts/Oxygen_Bold/oxygen-bold.eot'
import oxygenBoldSvg from 'assets/fonts/Oxygen_Bold/oxygen-bold.svg'
import oxygenBoldTtf from 'assets/fonts/Oxygen_Bold/oxygen-bold.ttf'
import oxygenBoldWoff from 'assets/fonts/Oxygen_Bold/oxygen-bold.woff'
import oxygenRegularEot from 'assets/fonts/Oxygen_Regular/oxygen-regular.eot'
import oxygenRegularSvg from 'assets/fonts/Oxygen_Regular/oxygen-regular.svg'
import oxygenRegularTtf from 'assets/fonts/Oxygen_Regular/oxygen-regular.ttf'
import oxygenRegularWoff from 'assets/fonts/Oxygen_Regular/oxygen-regular.woff'

export default createGlobalStyle`
  @font-face {
    font-family: 'oxygenRegular';
      src: local('oxygenRegular'), local('oxygenRegular'),
      url(${oxygenRegularEot}) format("embedded-opentype"),
      url(${oxygenRegularTtf}) format("truetype"),
      url(${oxygenRegularWoff}) format("woff"),
      url(${oxygenRegularSvg}) format("svg");
      font-style: normal;
  }
  @font-face {
    font-family: 'oxygenBold';
      src: local('oxygenBold'), local('oxygenBold'),
      url(${oxygenBoldEot}) format("embedded-opentype"),
      url(${oxygenBoldTtf}) format("truetype"),
      url(${oxygenBoldWoff}) format("woff"),
      url(${oxygenBoldSvg}) format("svg");
      font-style: normal;
  }
  :root{
    --fontRegular:'oxygenRegular',-apple-system, BlinkMacSystemFont,
      "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif,
      "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol",
      "Noto Color Emoji";
    --fontBold:'oxygenBold',-apple-system, BlinkMacSystemFont,
      "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif,
      "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol",
      "Noto Color Emoji";
  }
`
